// removed by extract-text-webpack-plugin
module.exports = {"box":"_3vduRbUKdxYW9vRadPONgo","select":"_3KEWRjUzm9EcWFdObEMAbw","active":"_1BPGZ_TjelOSyiyGHEtPjl","boxArrow":"VBwdJmfsO0xPUPmpJfryG","disable":"FCToRp9vw8wfdZHYJQ4s_","smallSelect":"_3a1posXYfBTO2O4HSnXEuM","value":"_1AWVpRbKlRihE6nTiD8cg0","placeHolder":"_1yciCsxZHHBJa160wAZHPE","btnClear":"_2k1ykl-7omuS6ctcK4y8gw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/SelectShop.scss
// module id = 1111
// module chunks = 0